/**
 * Update-available banner.
 *
 * main.js calls mountUpdateBanner(applyUpdate) when vite-plugin-pwa's
 * registerSW reports onNeedRefresh. Tapping "Reload" invokes the
 * applyUpdate callback, which calls updateSW(true) to activate the
 * new SW and reload.
 *
 * The banner pins to the top of the viewport (safe-area-aware) and
 * uses aria-live=polite so screen readers announce its arrival without
 * hijacking focus.
 *
 * Idempotent: calling twice is a no-op (design is "one global banner").
 *
 * Signature matches the Batch 2 stub in src/ui/modal-stubs.js:
 *   mountUpdateBanner(applyUpdate)
 */

const BANNER_ID = 'update-banner';

/**
 * @param {() => void} applyUpdate
 */
export function mountUpdateBanner(applyUpdate) {
  if (document.getElementById(BANNER_ID)) return;

  const banner = document.createElement('div');
  banner.id = BANNER_ID;
  banner.className = 'update-banner';
  banner.setAttribute('role', 'status');
  banner.setAttribute('aria-live', 'polite');
  banner.innerHTML = `
    <span class="update-banner__text">Update available — tap to reload</span>
    <button type="button" class="update-banner__action" data-action="reload">
      Reload
    </button>
  `;

  banner.querySelector('[data-action="reload"]').addEventListener('click', () => {
    try { applyUpdate(); } catch (_e) { /* caller bug */ }
  });

  document.body.appendChild(banner);
}
